export const XIVA_VERSION: string = process.env.REACT_APP_VERSION || 'DEV'
export const XIVA_GIT_COMMIT: string = process.env.REACT_APP_GIT_COMMIT || 'DEV'
export const XIVA_GIT_BRANCH: string = process.env.REACT_APP_GIT_BRANCH || 'DEV'
